import { LogoCombinedProps } from './types';

const usePresenter = (props: LogoCombinedProps): LogoCombinedProps => {
  return props;
};

export default usePresenter;
